export function getDefaultFilters() {
  return {
    pageNumber: 1,
    filterData: {
      filterOptions: {
        includeArchived: true
      },
      sortingOptions: {}
    }
  }
}
export function validateRequired(value) {
    let returnValue = false;
    if (value && value.length !== 0) {
        returnValue = true;
    }
    return returnValue;
}

export function validateEmail(email) {
    if(email) {
        const re = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
        return re.test(String(email).toLowerCase());
    }
    return true;
}

export function validatePassword(value) {
    let returnValue = false;
    if (value && value.length >= 6) {
        returnValue = true;
    } else if(!value) {
        returnValue = true;
    }
    return returnValue;
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/Dentists/helpers.js